import { Box, Link, List, ListItem, ListItemText, Typography } from '@mui/material';
import InformationForm from '../InformationForm/InformationForm';

function StartupInfoModal({ open, onClose }) {
  return (
    <InformationForm
      title="Thông báo gia hạn dịch vụ"
      open={open}
      onClose={onClose}
    >
      <Box sx={{ maxHeight: '70vh', overflowY: 'auto', pr: 1 }}>
        <Typography variant="body1" sx={{ mb: 1.5 }}>
          Kính gửi Quý đơn vị,
        </Typography>
        <Typography variant="body1" sx={{ mb: 1.5 }}>
          Công ty CP Đầu tư Phát triển Công nghệ Tân Thanh Phương xin chân thành cảm ơn Quý đơn vị đã tin tưởng sử dụng hệ thống truyền thanh thông minh trong thời gian qua.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1.5 }}>
          Hiện tại, Gói duy trì & vận hành hệ thống truyền thanh thông minh của Quý đơn vị đã đến thời hạn gia hạn.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          Gói dịch vụ bao gồm:
        </Typography>
        <List dense sx={{ listStyleType: 'disc', pl: 3, mb: 1 }}>
          <ListItem sx={{ display: 'list-item', py: 0 }}>
            <ListItemText primary="Lưu trữ và vận hành dữ liệu trên nền tảng Cloud" />
          </ListItem>
          <ListItem sx={{ display: 'list-item', py: 0 }}>
            <ListItemText primary="AI giọng đọc bản tin" />
          </ListItem>
          <ListItem sx={{ display: 'list-item', py: 0 }}>
            <ListItemText primary="Kết nối internet 4G cho thiết bị" />
          </ListItem>
          <ListItem sx={{ display: 'list-item', py: 0 }}>
            <ListItemText primary="Sao lưu dữ liệu và vận hành từ xa" />
          </ListItem>
          <ListItem sx={{ display: 'list-item', py: 0 }}>
            <ListItemText primary="Hỗ trợ kỹ thuật" />
          </ListItem>
        </List>
        <Typography variant="body1" sx={{ mb: 1.5 }}>
          Để đảm bảo hệ thống hoạt động ổn định, liên tục, kính đề nghị Quý đơn vị hoàn tất gia hạn trước ngày <strong>30/03/2026</strong>.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1.5 }}>
          Trong trường hợp chưa gia hạn, một số chức năng như điều hành từ xa, AI giọng đọc và lưu trữ Cloud có thể bị gián đoạn. Phần mềm bản quyền vẫn sử dụng bình thường.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1.5 }}>
          Sau khi hoàn tất thanh toán, dịch vụ sẽ được khôi phục đầy đủ trong vòng 24 giờ làm việc.
        </Typography>
        <Typography variant="body1" sx={{ mb: 0.5 }}>
          Thông tin liên hệ:
        </Typography>
        <List dense sx={{ listStyleType: 'disc', pl: 3, mb: 1 }}>
          <ListItem sx={{ display: 'list-item', py: 0 }}>
            <ListItemText primary="Hotline/Zalo: 0941 303 663" />
          </ListItem>
          <ListItem sx={{ display: 'list-item', py: 0 }}>
            <ListItemText primary="Điện thoại: 023 7888 6868" />
          </ListItem>
          <ListItem sx={{ display: 'list-item', py: 0 }}>
            <ListItemText primary="Email: gm@tanthanhphuong.vn" />
          </ListItem>
          <ListItem sx={{ display: 'list-item', py: 0 }}>
            <ListItemText primary="Website: www.vnmap.ai" />
          </ListItem>
        </List>
        <Typography variant="body1" sx={{ mb: 1.5 }}>
          Xin lỗi nếu thông báo này làm phiền trong trường hợp Quý đơn vị đã hoàn tất thanh toán.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1.5 }}>
          Chi tiết thông báo & cách thanh toán:{' '}
          <Link
            href="https://vnmap.ai/news/thong-bao-gia-han-goi-duy-tri-van-hanh-he-thong-truyen-thanh-thong-minh-20260319"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://vnmap.ai/news/thong-bao-gia-han-goi-duy-tri-van-hanh-he-thong-truyen-thanh-thong-minh-20260319
          </Link>
        </Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          Trân trọng cảm ơn!
        </Typography>
        <Typography variant="body1">
          CÔNG TY CP ĐẦU TƯ PHÁT TRIỂN CÔNG NGHỆ TÂN THANH PHƯƠNG
        </Typography>
      </Box>
    </InformationForm>
  );
}

export default StartupInfoModal;
